import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AutenticacaoService } from '../../autenticacao/autenticacao.service';


@Injectable()
export class FrontInterceptor implements HttpInterceptor {

  static isRefreshingToken = false;
  private requestCache = new Map<HttpHandler, HttpRequest<any>>();
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private injector: Injector) { }

  public gerarCabecalho(req: HttpRequest<any>): HttpRequest<any> {
    let reqClone: HttpRequest<any>;

    if (req.url.indexOf('/session/') > -1 || req.url.indexOf('/configs/login') > -1 || req.url.indexOf('/odonto/prestador') > -1) {
      reqClone = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    } else {
      let headers;
      if (req.url.indexOf('/Unimed/GetImage?') > -1) {
        headers = req.headers.set('Authorization',`${this.injector.get(AutenticacaoService).usuarioLogado.docuwareAuthToken}`);
      } else {
        if (req.url.indexOf('token-corporativo/v1/token') > -1 || req.url.indexOf('tokencorporativo/v1/token') > -1) {
          headers = req.headers
                    .set('Authorization', this.injector.get(AutenticacaoService).tokenAcess)
                    .set('Content-Type', 'application/json')
                    .set('x-api-key', environment.tokenXApiKey);
        } else {
          headers = req.headers.set('Authorization', this.injector.get(AutenticacaoService).tokenAcess);
        }
      }

      reqClone = req.clone({ headers: headers });
    }
    return reqClone;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): any/*Observable<HttpEvent<any>>*/ {
    if (req.url.indexOf('/session/') > -1) {
      return next.handle(this.gerarCabecalho(req));
    } else {
      return next.handle(this.gerarCabecalho(req)).do(
        (event: HttpEvent<any>) => {
          /*do something with response?*/
        }).catch((err: any, restart: any) => {
          if (err.status === 401 || err.status === 403) {
            return this.handle401Error(req, next, restart);
          } else {
            return Observable.throw(err);

          }
        });
    }
  }

  public handle401Error(req: HttpRequest<any>, next: HttpHandler, restart: any): any {
    if (!FrontInterceptor.isRefreshingToken) {
      FrontInterceptor.isRefreshingToken = true;
      this.requestCache.set(next, req);
      this.tokenSubject.next(null);
      this.injector
        .get(AutenticacaoService)
        .atualizarToken()
        .subscribe((data: any) => {
          FrontInterceptor.isRefreshingToken = false;
          this.tokenSubject.next(data.tokenAcess);
        },
          (error: any) => {
            FrontInterceptor.isRefreshingToken = false;
            localStorage.setItem('mensagem-logout', 'Sua sessão expirou, é necessario realizar o login novamente');
            this.injector
              .get(AutenticacaoService)
              .logout();
          });
      return this.tratarReenvio(req, next);
    } else {
      return this.tratarReenvio(req, next);
    }
  }

  private tratarReenvio(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.tokenSubject
      .filter(token => token != null)
      .take(1)
      .switchMap(token => {
        return next.handle(this.gerarCabecalho(req));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base/util/front.interceptor.ts